<div class="gallery-print-options">
  <a class="icon-close" onclick="$.fancybox.close();" href="javascript:;"></a>
  <h2>Which size print would you like to purchase?</h2>
  {{#each options}}
  <a href="#" class="btn-print-option" data-product-id="{{ product_id }}" data-option-id="{{ option_id }}"><span class="print-size">{{ product_name }}</span><br/><span class="print-price">${{ product_price }} / Print</span></a>
  {{/each}}
</div>
